<template>
	<div id="app" class="fillcontain" @mousemove="setMouseMove">
		<commontop v-if="$route.meta.typePage == 2" @topclick="topclick"></commontop>
		<!-- <GoTop v-if="$route.path != '/login/UPLoginPage' && '/AORcode'"></GoTop> -->
		<GoTop v-if="GoTopWhiteFlag"></GoTop>
		<router-view />

		<!-- 报量小助手浮窗 -->
		<div class="floating-helper" v-if="showFloatingHelper">
			<div class="close-btn" @click.stop="closeFloatingHelper">
				<img src="@/assets/home/icon_fc_gb_n@2x.png" alt="close">
			</div>
			<img src="@/assets/home/img_ww_zs_n@2x.png" alt="helper" @click="goToHomePage">
		</div>
	</div>
</template>
<script>
	import commontop from './components/common-top.vue'
	import GoTop from './views/views/home/GoTop/goTop.vue'
	export default {
		components: {
			commontop,
			GoTop
		},
		name: 'App',
		data() {
			return {
				showFloatingHelper: false,
				timmer: null,
				count: 1800,
				header_show: true,
				footer_show: true,
				GoTopWhiteFlag: false,
				path: '',
				dataORchannel: null,
				MenuList: {},
				GoTopWhite: [
					"/",
					"/login/UPLoginPage",
					"/AORcode",
				],
				whiteNodeIDs: [], //页面权限白名单
				whiteRouterList: [
					"/homeCom/HomePage",
					"/login/CodeLoginPage",
					"/login/UPLoginPage",
					"/homeCom/CompanyIinformation",
					"/homeCom/FileAdministration",
					"/homeCom/IndexCcenter",
					"/homeCom/EarlyWarningCaceability",
					"/License/BusinessLcenter",
					"/homeCom/Datadownload",
					"/homeCom/Informationrelease",
					"/homeCom/ComplianceTrain",
					"/homeCom/ProductTricense",
					"/homeCom/WorkRepor"
				]
			}
		},
		created() {
			this.path = this.$route.path;
			this.dataORchannel = this.$store.state.dataORchannel
			// if (this.$route.path != '/login/UPLoginPage' && this.$route.path != '/') {
			//   this.$fishkefu.init()
			//   this.$fishkefu.Config()
			//   this.$fishkefu.wacthSdk()
			// } 
		},
		mounted() {
			// const loading = this.$loading({
			// 	lock: true,
			// 	text: '加载中...',
			// 	spinner: 'el-icon-loading',
			// 	background: 'rgba(255,255,255,0.3)'
			// });
			this.setMouseMove();
		},
		methods: {
			// 检查是否显示悬浮窗
			checkFloatingHelper(path) {
				const isMatch = path.indexOf('/SMS') > -1 || path.indexOf('/WMS') > -1;
				const isClosed = localStorage.getItem('floatingHelperClosed');

				if (isMatch && !isClosed) {
					this.showFloatingHelper = true;
				} else {
					this.showFloatingHelper = false;
				}
			},
			closeFloatingHelper() {
				this.showFloatingHelper = false;
				localStorage.setItem('floatingHelperClosed', 'true');
			},
			goToHomePage() {
				this.$router.push('/homePage');
			},
			//是否显示头部
			header: function(bool) {
				this.header_show = bool;
			},
			topclick(par) {},
			setMouseMove(e) {
				if (this.timmer) {
					this.count = 1800;
					clearInterval(this.timmer)
					this.timmer = null;
				}
				this.timmer = setInterval(() => {
					//console.log('计时开始------>', this.count)
					this.count--;
					if (!this.GoTopWhite.includes(location.hash.replace('#', ''))) {
						if (this.count < 10) {
							this.$message.error(`由于您长时间未操作，系统将在${this.count}秒后退出登录！`);
						}
						if (this.count <= 1) { //60s*30min
							clearInterval(this.timmer)
							this.timmer = null;
							this.$store.commit("OUT_LOGINI")
							localStorage.clear();
							this.$router.push({
								name: 'CodeLoginPage'
							})
							//window.close();
							//console.log('退出系统------>')
						}
					} else {
						this.count = 1800;
					}
				}, 1000);
			}
		},
		watch: {
			$route: {
				handler(to, from) {
					this.checkFloatingHelper(to.path);
					// console.log(!this.GoTopWhite.includes(to.path),to.path,'ssss');

					if (to.path != '/AORcode') {
						try {
							if (!this.GoTopWhite.includes(to.path)) {
								this.GoTopWhiteFlag = true
							}
							if (to.path == '/login/UPLoginPage') {
								this.GoTopWhiteFlag = false
								return
							}
							// document.querySelectorAll('#YSF-PANEL-INFO')[0].style.opacity = '1'
							if (this.$store.state.MenusState == 0) {
								this.whiteNodeIDs = []
								return
							}
						} catch (error) {
							// console.log(error);
						} finally {
							if (to.path == '/homeCom/HomePage' || to.name == 'homePage') {
								return
							}
							if (to.fullPath != "/login/UPLoginPage" && to.fullPath != "/" && to.fullPath !=
								"/login/CodeLoginPage") {
								let NodeID = to.query.NodeID,
									MenuID = to.query.MenuID;
								this.MenuList = this.$store.state.MenusData || localStorage.getItem('MenusData')
								/*
								 *@Author: 史泽
								 *@Date: 2022-01-13 11:12:32
								 *@Description: 控制不同用户页面权限【上报过滤、渠道过滤】 （过滤操作）
								 */
								this.MenuList.Menus.map((item, index) => {
									if (!this.whiteNodeIDs.includes(item.NodeID)) {
										this.whiteNodeIDs.push(item.NodeID)
									}
									item.Nodes.map((items, indexs) => {
										if (!this.whiteNodeIDs.includes(items.NodeID)) {
											this.whiteNodeIDs.push(items.NodeID)
										}
										if (items.Nodes != null) {
											items.Nodes.map((itemts, indexts) => {
												if (!this.whiteNodeIDs.includes(itemts.NodeID)) {
													this.whiteNodeIDs.push(itemts.NodeID)
												}
											})
										}
									})
								})
								/*
								 *@Author: 史泽
								 *@Date: 2022-01-13 11:47:40
								 *@Description: 渠道过滤
								 */
								this.MenuList.CusWebMenus.map((item, index) => {
									if (!this.whiteNodeIDs.includes(item.NodeID)) {
										this.whiteNodeIDs.push(item.NodeID)
									}
									if (item.Nodes != null) {
										item.Nodes.map((items, indexs) => {
											if (!this.whiteNodeIDs.includes(items.NodeID)) {
												this.whiteNodeIDs.push(items.NodeID)
											}
											if (items.Nodes != null) {
												items.Nodes.map((itemts, indexts) => {
													if (!this.whiteNodeIDs.includes(itemts
															.NodeID)) {
														this.whiteNodeIDs.push(itemts.NodeID)
													}
												})
											}
										})
									}
								})
								if (!this.whiteNodeIDs.includes(NodeID)) {
									this.$notify.error({
										title: '错误',
										message: '该用户没有权限'
									});
									this.$router.push({
										path: from.fullPath
									})
									return
								}
								if (MenuID && !this.whiteNodeIDs.includes(MenuID)) {
									this.$notify.error({
										title: '错误',
										message: '该用户没有权限'
									});
									this.$router.push({
										path: from.fullPath
									})
									return
								}
								// 控制顶部
								this.dataORchannel = !this.whiteRouterList.includes(to.path.toString())
							}
						}
					}

				},
				deep: true,
				immediate: true
			}
		}
	}
</script>
<style lang="less">
	@import "./style/common.less";

	.el-button--primary {
		color: #fff;
		background-color: #e71d43 !important;
		border-color: #e71d43 !important;
	}

	.el-month-table td.end-date .cell,
	.el-month-table td.start-date .cell {
		background-color: #e71d43 !important;
	}

	.el-tabs__item:hover {
		color: #e71d43 !important;
	}

	.el-tabs__item.is-active {
		color: #e71d43 !important;
	}

	.floating-helper {
		position: fixed;
		bottom: 150px;
		right: 80px;
		z-index: 9999;
		cursor: pointer;
		border-radius: 8px;
		ovrflow: hidden;

		img {
			width: 240px;
			height: auto;
			display: block;
			border-radius: 8px;
			ovrflow: hidden;
		}

		.close-btn {
			position: absolute;
			top: 10px;
			right: 10px;
			width: 24px;
			height: 24px;
			cursor: pointer;
			z-index: 10000;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	/* 全局表格行选中背景色 */
	.el-table__body tr:has(.el-table-column--selection .el-checkbox__input.is-checked) > td {
		background-color: #E5E9F2 !important;
	}
</style>
